<template>
  <div class="container">
    <my-header :curHeader="-1"></my-header>
    <main>
      <div v-if="obj.id" class="detail-header">
        <p class="detail-header-title">{{ obj.title }}</p>
        <p class="detail-header-time">
          <span>发布时间：{{ obj.publishTime }}</span>
          <span v-if="obj.source">{{ '来源：' + obj.source }}</span>
        </p>

      </div>
      <div class="detail-content" v-html="obj.content"></div>
    </main>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHeader from '@/components/Header'
import MyFooter from '@/components/Footer'

export default {
  components: {
    MyHeader,
    MyFooter,
  },
  data() {
    return {
      obj: {}
    }
  },
  mounted() {
    let obj = localStorage.getItem('curArticle')
    this.obj = JSON.parse(obj)
  },
}
</script>

<style lang="scss" scoped>
.container{
  main {
    width: 1200px;
    min-height: 500px;
    margin: 50px auto;
    background: #fff;
    .detail-header {
      width: 100%;
      border-top: 8px solid #1279EC;
      .detail-header-title {
        font-size: 24px;
        font-weight: bold;
        color: #1C4281;
        padding: 20px 0;
        text-align: center;
      }

      /* 这里的伪元素一定要加上，不然span元素不能两端对齐 */
      .detail-header-time:after {
        content: "";
        display: inline-block;
        overflow: hidden;
        width: 100%;
      }

      .detail-header-time {
        width: 1000px;
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        color: #8F98A0;
        background: #F0F7FF;
        margin: 0 auto;
        text-align: center;
        /*text-align: center;*/
        span{
          /* 设置盒子为行内块 */
          display: inline-block;
          /* 设置盒子内元素水平居中 */
          text-align: center;
          /* 设置盒子内容垂直居中 */
          margin: 0 10px;
        }
      }
    }
    .detail-content {
      width: 1000px;
      margin: 0 auto;
      padding: 30px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newsDetail/index.vue